import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import useMediaQuery from '@/utils/useMediaQuery';

import { ChartIcon } from '../../icons/Icons';
import { INTERNAL_LINKS } from '../../utils';
import { InfoText } from '../global/InfoText';
import { ProductIllustration } from '../global/ProductIllustration';
import { FloatingText, Illustrations, Section } from '../global/sharedStyles';

const Wrapper = styled(Section)`
  .info-text {
    max-width: 440px;
  }
`;

const BeautifulVizIllustrations = styled(Illustrations)`
  height: 672px;
  margin-top: 180px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    margin-top: 50px;
    height: 642px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    height: 325px;
  }
`;

const ChartCellIllustration = styled(ProductIllustration)`
  top: 116px;
  left: -40px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    top: 66px;
    left: -20px;

    img {
      width: 371px;
    }
  }
`;

const MapCellIllustration = styled(ProductIllustration)`
  top: 0;
  right: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    top: 0;
    right: 10px;

    img {
      width: 287px;
    }
  }
`;

const SingleValueCellIllustration = styled(ProductIllustration)`
  top: 311px;
  right: -10px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    top: 187px;
    right: -20px;

    img {
      width: 144px;
    }
  }
`;

const TableDisplayCellIllustration = styled(ProductIllustration)`
  top: 327px;
  right: 220px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    top: 168px;
    right: -10px;

    img {
      width: 305px;
    }
  }
`;

export const SectionBeautifulViz: React.ComponentType = React.memo(() => {
  const theme = useTheme();
  const shouldCollapse = useMediaQuery(theme.mediaQueryString.MEDIUM);

  return (
    <Wrapper>
      <FloatingText>
        <InfoText
          description="Powerful cells to create interactive charts, maps, and conditionally-formatted tables."
          icon={<ChartIcon />}
          link={INTERNAL_LINKS.AppBuilder}
          title="Beautiful, built-in viz"
        />
      </FloatingText>
      <BeautifulVizIllustrations>
        <TableDisplayCellIllustration
          cellLabel="Table Display cell"
          hideHeader={shouldCollapse}
          imgPath="notebooks/table-display-cell"
        />
        <MapCellIllustration
          cellLabel="Map cell"
          hideHeader={shouldCollapse}
          imgPath="notebooks/map-cell"
        />
        <ChartCellIllustration
          cellLabel="Chart cell"
          hideHeader={shouldCollapse}
          hideHeaderActions={true}
          imgPath="notebooks/chart-cell"
        />
        <SingleValueCellIllustration
          cellLabel="Single Value cell"
          hideHeader={true}
          imgPath="notebooks/single-value-cell"
        />
      </BeautifulVizIllustrations>
    </Wrapper>
  );
});
